// 品牌資訊
export const BRAND = {
  NAME: 'Picklemaster Taiwan',
  NAME_ZH: '匹克大師台灣',
  TAGLINE: '台灣匹克球玩家社群與資源平台',
  DESCRIPTION: '一起玩匹克球！分享球場、交流技巧、尋找球友',
} as const;

// 球場尺寸常數（英尺）
export const COURT_DIMENSIONS = {
  WIDTH: 20, // 英尺
  LENGTH: 44, // 英尺
  NON_VOLLEY_ZONE: 7, // 非截擊區（廚房區）深度
  SERVICE_AREA_WIDTH: 10, // 發球區寬度
};

// 學習路徑類型
export const LEARNING_PATHS = {
  BEGINNER: 'beginner',
  INTERMEDIATE: 'intermediate',
  ADVANCED: 'advanced',
} as const;

// 頁面路由
export const ROUTES = {
  HOME: '/',
  RULES: '/rules',
  NEWCOMER_GUIDE: '/newcomer-guide',
  EQUIPMENT: '/equipment',
  PRO_PLAYERS: '/pro-players',
  LEARNING_PATHS: '/learning-paths',
  LEARNING: '/learning',
  COURTS: '/courts',
  GAME: '/game',
  SCORER: '/scorer',
  RESOURCES: '/resources',
  ABOUT: '/about',
  FAQ: '/faq',
  TOURNAMENTS: '/tournaments',
  AEPL: '/aepl',
  GLOSSARY: '/glossary',
  RATINGS: '/ratings',
  ARTICLES: '/articles',
  ARTICLE_DETAIL: '/articles/:slug',
  TECHNIQUES: '/techniques',
  TECHNIQUE_DETAIL: '/techniques/:slug',
  COURT_DETAIL: '/courts/:slug',
  PLAYER_DETAIL: '/players/:slug',
  HISTORY: '/history',
  PADDLE_DATABASE: '/paddles',
  PADDLE_DETAIL: '/paddles/:slug',
  VIDEOS: '/videos',
  TRAINING_PROGRAMS: '/training-programs',
  TRAINING_PROGRAM_DETAIL: '/training-programs/:slug',
  PLAYBOOK: '/playbook',
  HALL_OF_FAME: '/hall-of-fame',
  TOOLS: '/tools',
  TOOL_DUPR: '/tools/dupr-simulator',
  TOOL_ROTATION: '/tools/rotation',
  TOOL_BRACKET: '/tools/bracket',
  TOOL_COURT_LINES: '/tools/court-lines',
  NEWS: '/news/:id',
  PRIVACY_POLICY: '/privacy-policy',
  CONTACT: '/contact',
  DATA_METHOD: '/data-method',
  PLAY: '/play',
} as const;

// 球場類型
export const COURT_TYPES = {
  INDOOR: 'indoor',
  OUTDOOR: 'outdoor',
} as const;

// 收費類型
export const FEE_TYPES = {
  FREE: 'free',
  PAID: 'paid',
} as const;

// 地圖預設中心點（台灣中心）
export const DEFAULT_MAP_CENTER = {
  lat: 24.0,
  lng: 121.0,
  zoom: 7,
} as const;
